import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, Checkbox } from 'antd';
import { useScoringCategories } from '@/features/constructorScoringCategory/hooks';
import { ScoringConstructorApi } from '@/features/constructorScoringCategory/api';
import { usePopups } from '@/hooks';

export const ScoringRiskCategories = ({ questionSectionTypeId, closeModal }) => {
  const { showErrorToast } = usePopups();
  const { t } = useTranslation();
  const { data, isLoading } = useScoringCategories();
  const [initialRiskCategories, setInitialRiskCategories] = useState([]);
  const [finalRiskCategories, setFinalRiskCategories] = useState([]);

  useEffect(() => {
    if (data)
      data.forEach((category) => {
        if (category.questionSectionTypes && category.questionSectionTypes.length) {
          const questionnaireWithCategory = category.questionSectionTypes.find(
            (i) => i.id === questionSectionTypeId
          );
          if (questionnaireWithCategory) {
            setFinalRiskCategories((prevValue) => [...prevValue, category.id]);
            setInitialRiskCategories((prevValue) => [...prevValue, category.id]);
          }
        }
      });
  }, [data]);

  const onChange = (e, categoryId) => {
    let newCategories;

    if (e.target.checked) {
      newCategories = [...finalRiskCategories, categoryId];
    } else {
      newCategories = finalRiskCategories.filter((a) => a !== categoryId);
    }

    setFinalRiskCategories(newCategories);
  };

  const onAdd = async () => {
    try {
      // add new categories
      for (const category of finalRiskCategories) {
        if (!initialRiskCategories.includes(category)) {
          await ScoringConstructorApi.addScoringCategoryToQuestionnaire({
            questionSectionTypeId: questionSectionTypeId,
            categoryScoringId: category
          });
        }
      }
      // delete old categories
      for (const category of initialRiskCategories) {
        if (!finalRiskCategories.includes(category)) {
          await ScoringConstructorApi.deleteScoringCategoryFromQuestionnaire({
            questionSectionTypeId: questionSectionTypeId,
            categoryScoringId: category
          });
        }
      }
      closeModal();
    } catch (e) {
      showErrorToast(e, true);
      console.error(e);
    }
  };

  if (isLoading) return <div>{t('Loading')}...</div>;

  return (
    <div>
      <Box>
        {data.map((category) => (
          <CategoryBox>
            <Checkbox
              onChange={(e) => onChange(e, category.id)}
              checked={finalRiskCategories.includes(category.id)}
            >
              {category.name} ({category.minPoints}-{category.maxPoints} points)
            </Checkbox>
          </CategoryBox>
        ))}
      </Box>
      <BtnBox>
        <Button onClick={onAdd} type='primary' style={{ marginTop: '30px' }}>
          {t('Add categories')}
        </Button>
      </BtnBox>
    </div>
  );
};

const Box = styled.div`
  height: 600px;
  overflow-y: scroll;
`;

const CategoryBox = styled.div`
  padding-left: 20px;
`;

const BtnBox = styled.div`
  text-align: right;
`;
